import {
	Activity,
	Company,
	DayString,
	Site,
	UserDetails,
} from '../../../../constants/Common';
import { Note } from '../../../../constants/Note';
import { SiteLog } from '../../../../constants/SiteLogs';
import { Timesheet } from '../../../../constants/Timesheet/Timesheet';
import { NewTimesheetStatus } from '../../../../constants/Timesheet/TimesheetUtilities';
import { EventType } from './CreateSnackbar';
import { HeaderFields } from './HeaderFields';

export type NewActivity = Pick<Activity, 'id' | 'day' | 'hours'> & {
	activity: Activity['activity'] | null; // null temp new
	hasError: boolean;
};

export const isNonNullNewActivity = (
	activity: NewActivity,
): activity is NewActivity & {
	activity: NonNullable<NewActivity['activity']>;
} => activity.activity !== null;

type CreateStateBase = {
	creator: Timesheet['lastEditedBy'];
	duplicateTimesheet: Timesheet | null;
	initialLoad: boolean;
	duplicateTimesheetsLoading: boolean;
	confirmModalOpen: boolean;
	siteLogs: SiteLog[];
	headerErrors: Record<HeaderFields, boolean>;
	feedbackSnackbarEvent: EventType | null;
	selectedWorker: Pick<
		UserDetails,
		| 'userID'
		| 'company'
		| 'companyID'
		| 'contractedTo'
		| 'displayName'
		| 'recentClients'
		| 'workerType'
	> | null;
	selectedClient: Pick<Company, 'id' | 'name'> | null;
	selectedSite: Site | null;
	selectedTimesheetStatus: NewTimesheetStatus;
	selectedWeekEnding: Date;
	activities: Record<DayString, Record<Activity['id'], NewActivity>>;
	breaks: Record<DayString, number>;
	notes: Record<DayString, Pick<Note, 'note' | 'user'>>;
	authorizedActions: Record<
		| 'canChangeClient'
		| 'canChangeSite'
		| 'canChangeStatus'
		| 'isRecruitmentSite',
		boolean
	>;
};

export type CreateState = CreateStateBase & {
	initialState: CreateStateBase;
};
